<div class="ack-overlay">
  <div class="ack-overlay-header">
    <h2 class="ack-overlay-title">CUSTOMER ORDER ACKNOWLEDGMENT</h2>
    <button
      mat-button
      type="button"
      (click)="dialogRef.close()"
      aria-label="Close acknowledgment"
    >
      CLOSE
    </button>
  </div>
  <p class="ack-language">{{ language }}</p>
  <p class="ack-note" *ngIf="hasCompletionDate">
    Requested completion date is a customer request and is not an unconditional guarantee.
  </p>
  <div class="signature-pad-wrap">
    <canvas
      #signaturePad
      class="signature-pad"
      (mousedown)="startDraw($event)"
      (mousemove)="moveDraw($event)"
      (mouseup)="endDraw()"
      (mouseleave)="endDraw()"
      (touchstart)="startDraw($event)"
      (touchmove)="moveDraw($event)"
      (touchend)="endDraw()"
    ></canvas>
    <div class="signature-line" aria-hidden="true"></div>
  </div>
  <div class="ack-actions">
    <button mat-button type="button" (click)="clearSignature()">CLEAR</button>
    <button
      mat-raised-button
      color="primary"
      type="button"
      [disabled]="!hasSignature"
      (click)="confirm()"
    >
      SIGN &amp; ACKNOWLEDGE
    </button>
  </div>
</div>
